import React, { useEffect, useState } from "react";
import _groupBy from "lodash/groupBy";
import { Link, useHistory, useParams } from "react-router-dom";

import Layout from "../../../../components/Layout";
import Container from "../../../../components/Container";
import Flex from "../../../../components/Flex";
import Content from "../../../../components/Content";
import Button from "../../../../components/Button";
import ButtonList from "../../../../components/ButtonList";
import LinkButton from "../../../../components/LinkButton";
import Breadcrumbs from "../../../../components/Breadcrumbs";
import { useMessageToast } from "../../../../components/MessageProvider";
import Modal from "../../../../components/ModalPopup";
import DataTable, {
  DropDownListFilter,
  SelectInputFilter
} from "../../../../components/DataTable";
import { useAuthState } from "../../../../components/AuthProvider";
import Tooltip from "../../../../components/Tooltip";
import Spinner from "../../../../components/Loader/Spinner";
import handleResponse from "../../../../utils/handleFetchResponse";
import fetchConfig from "../../../../utils/fetchConfig";

import styles from "./ViewExternalVendor.module.scss";

const ViewExternalVendor = () => {
  const moment = require("moment-timezone");
  const externalVendorApiUrl = `${process.env.REACT_APP_SVC_APIS_DOMAIN}/externalvendor`;
  const { id } = useParams();

  const history = useHistory();
  const { user } = useAuthState();
  const { selectedClient } = user.preferences;
  const toast = useMessageToast();

  const [externalVendorData, setExternalVendorData] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);

  useEffect(() => {
    const config = {
      headers: {
        clientId: selectedClient.oid,
        "Content-Type": "application/json",
        userId: user.username
      }
    };
    const getExternalVendor = async () => {
      setIsLoading(true);
      const response = await fetch(`${externalVendorApiUrl}/get/${id}`, config);
      if ((await response.status) == 200) {
        const data = await response.json();
        setExternalVendorData(data);
        setIsLoading(false);
        setHasLoaded(true);
      } else {
        toast.error("Something went wrong while fetching the vendor");
        setIsLoading(false);
      }
    };

    if (!hasLoaded && !isLoading) {
      setIsLoading(true);
      getExternalVendor();
      setIsLoading(false);
      setHasLoaded(true);
    }
  }, [setIsLoading, setHasLoaded, hasLoaded, isLoading]);

  let loadedBreadcrumbs = "";
  if (isLoading) {
    loadedBreadcrumbs = "Loading ...";
  } else if (hasLoaded) {
    loadedBreadcrumbs = (
      <Breadcrumbs>
        <Breadcrumbs.Item render={() => <Link to="/">Home</Link>} />
        <Breadcrumbs.Item
          render={() => <Link to="/admin">Administration</Link>}
        />
        <Breadcrumbs.Item
          render={() => <Link to="/admin/externalvendors">Vendors</Link>}
        />
        <Breadcrumbs.Item
          last
          render={() => `Vendor: ${externalVendorData.vendorName}`}
        />
      </Breadcrumbs>
    );
  }

  return (
    <Layout>
      <Container>
        <Flex gutter={3}>
          <Flex.Item span={12}>{loadedBreadcrumbs}</Flex.Item>
          {isLoading ? (
            <Spinner />
          ) : hasLoaded ? (
            <Flex.Item span={12}>
              <Content>
                <h1>Vendor: {externalVendorData.vendorName}</h1>
              </Content>
              <div className={styles.base}>
                <div className={styles.detailsFlex}>
                  <h3>Vendor Details</h3>
                  <div>
                    <Button
                      className={styles.margin}
                      primary
                      onClick={() => {
                        history.push(`${id}/edit`);
                      }}
                    >
                      Edit
                    </Button>
                  </div>
                </div>
                <div className={styles.details}>
                  <div>
                    <h4>Vendor ID</h4>
                    <span>{externalVendorData.vendorId}</span>
                  </div>
                  <div>
                    <h4>Name</h4>
                    <span>{externalVendorData.vendorName}</span>
                  </div>
                  <div>
                    <h4>Description</h4>
                    <span>
                      {externalVendorData.vendorDesc
                        ? externalVendorData.vendorDesc
                        : "-"}
                    </span>
                  </div>
                  <div>
                    <h4>DUR ID</h4>
                    <span>{externalVendorData.durId}</span>
                  </div>
                  <div>
                    <h4>Start Date</h4>
                    <span>{externalVendorData.startDate}</span>
                  </div>
                  <div>
                    <h4>Expiry Date</h4>
                    <span>{externalVendorData.expiryDate}</span>
                  </div>
                  <div>
                    <h4>Last Updated Date</h4>
                    <span>{externalVendorData.lastUpdated}</span>
                  </div>
                </div>
              </div>
            </Flex.Item>
          ) : null}
        </Flex>
      </Container>
    </Layout>
  );
};

export default ViewExternalVendor;
